export class OpenIdError extends Error {
    data;
    constructor(message, { data }) {
        super(message);
        this.data = data;
    }
}
